export const SubscriptionForm = {
  PetName: 'pet-name',
  PetBirthday: 'pet-birthday',
  PetBreed: 'pet-breed',
  PetWeight: 'pet-weight',
  SubmitBtn: 'submit-btn',
  AddAnotherPetBtn: 'add-pet-btn',
} as const;
